"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FaqItem = exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireDefault(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _class, _descriptor, _descriptor2, _temp, _class3, _descriptor3, _descriptor4, _temp2;

var FaqBlock = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(FaqBlock, _Block);

  function FaqBlock() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, FaqBlock);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(FaqBlock)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "question", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "answer", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(FaqBlock, [{
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement("div", {
        className: "inner-content"
      }, _react.default.createElement(FaqItem, {
        question: this.question,
        answer: this.answer
      }));
    }
  }]);
  return FaqBlock;
}(_base.default), _temp2), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "question", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "answer", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = FaqBlock;
var FaqItem = (_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  babelHelpers.inherits(FaqItem, _React$Component);

  function FaqItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, FaqItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(FaqItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "question", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "answer", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      expanded: null
    };
    return _this;
  }

  babelHelpers.createClass(FaqItem, [{
    key: "onClick",
    value: function onClick() {
      this.setState(function (_ref) {
        var expanded = _ref.expanded;
        return {
          expanded: !expanded
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: _classList.default.join('faq-item-2', this.state.expanded === true ? 'expanded' : this.state.expanded === false ? 'collapsed' : null)
      }, _react.default.createElement("div", {
        className: "toggle",
        onClick: this.onClick
      }, _react.default.createElement("span", {
        className: "material-icons"
      })), _react.default.createElement("div", {
        className: "question",
        onClick: this.onClick
      }, this.question), _react.default.createElement("div", {
        className: "answer",
        dangerouslySetInnerHTML: {
          __html: this.answer
        }
      }));
    }
  }]);
  return FaqItem;
}(_react.default.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "question", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "answer", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "onClick", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype)), _class);
exports.FaqItem = FaqItem;